<template>
  <el-dialog
    class="product-point-modal"
    :modal="false"
    width="500px"
    :close-on-click-modal="false"
    :title="type === 'recommend' ? '系统推荐卖点' : '系统推荐行动号召'"
    :visible.sync="modalVisible"
  >
    <div class="select-wrap">
      <el-checkbox-group v-model="checkList" :max="10">
        <el-checkbox v-for="item in productSellingList" :key="item" class="word-item" :label="item"></el-checkbox>
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="select-text">已选：{{ checkList.length }}/10</span>
      <el-button @click="modalVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmProduct">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { getProductSellPoint, getProductCallAction } from "@/api/promotion.js";
export default {
  components: {},
  data() {
    return {
      modalVisible: false,
      productSellingList: [],
      type: "recommed",
      checkList: [],
    };
  },

  methods: {
    showModal(type) {
      this.type = type;
      this.getList(type);
      this.checkList = [];
      this.modalVisible = true;
    },
    getList(type) {
      const api = type === "recommend" ? getProductSellPoint : getProductCallAction;
      api({
        advertiserId: this.adCount,
      }).then((res) => {
        this.productSellingList = res.data;
      });
    },
    confirmProduct() {
      this.modalVisible = false;
      this.$emit("selectOk", this.checkList, this.type);
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
    }),
  },
};
</script>

<style lang="less" scoped>
.product-point-modal {
  .select-wrap {
    display: flex;
    background: #f6f8f7;
    flex-wrap: wrap;
    padding: 12px;
    min-height: 100px;
    .word-item {
      width: 175px;
      margin-bottom: 4px;
    }
  }
  /deep/ .el-dialog__footer {
    padding: 0px 34px 16px 34px;
    position: relative;
    .select-text {
      position: absolute;
      left: 30px;
      top: 10px;
      font-size: 14px;
    }
  }
}
</style>
